/**
 * @file index.tsx
 *
 * @fileoverview Renders a quote by the author.
 */
import React from "react";
import { useIsMobile } from "../../../hooks/useIsMobile";
import QuoteIcon from "@jq-icons/Quote";
import FlexItems from "../../02-atoms/06-layout/03-flex";
import FlexItem from "../../02-atoms/06-layout/03-flex/02-flex-item";
import Text from "../../02-atoms/13-text/03-text";
import styles from "./quote.module.scss";

interface QuoteProps {
  /**
   * The quote text.
   */
  text: string;
  /**
   * The author name.
   */
  author?: string;
  /**
   * The image element.
   */
  Image?: React.ReactNode;
  /**
   * Show the author prefix.
   *
   * @default true
   */
  showAuthorPrefix?: boolean;
}

export default function Quote({ author, text, Image, showAuthorPrefix = true }: QuoteProps) {
  const isMobile = useIsMobile();

  return (
    <>
      <FlexItems gap={8} flexWrap="nowrap" alignItems="center">
        {Image && !isMobile && (
          <FlexItem>
            <div className={styles.styleQuoteImage}>{Image}</div>
          </FlexItem>
        )}
        <FlexItem>
          <FlexItems flexDirection="column" alignItems="center" gap={3}>
            <QuoteIcon />
            <Text fontSize={4} fontWeight={600} className={styles.quoteText}>
              {text}
            </Text>
            {author && (
              <Text textAlign="center" className={styles.quoteAuthor}>
                {showAuthorPrefix ? <>&#8212; </> : null}{author}
              </Text>
            )}
          </FlexItems>
        </FlexItem>
      </FlexItems>
      {Image && isMobile && (
        <FlexItems justifyContent="center">
          <FlexItem marginTop={6}>
            <div className={styles.styleQuoteImage}>{Image}</div>
          </FlexItem>
        </FlexItems>
      )}
    </>
  );
}

export { Quote };
